import graphqlClient from "../../../apollo";

class ProductCategoryProvider {

    findProductCategory(id) {
        return graphqlClient.query({
            query: require('./gql/ProductCategory/findProductCategory.graphql'),
            fetchPolicy: "network-only",
            variables: {id:id}
        })
    }

    fetchProductCategory() {
        return graphqlClient.query({
            query: require('./gql/ProductCategory/fetchProductCategory.graphql'),
            fetchPolicy: "network-only",
        })
    }

    fetchProductCategoryActive() {
        return graphqlClient.query({
            query: require('./gql/ProductCategory/fetchProductCategoryActive.graphql'),
            fetchPolicy: "network-only",
        })
    }

    paginateProductCategory(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/ProductCategory/paginateProductCategory.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createProductCategory(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/ProductCategory/createProductCategory.graphql'),
            variables: {input}
        })
    }

    updateProductCategory(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/ProductCategory/updateProductCategory.graphql'),
            variables: {id, input}
        })
    }

     deleteProductCategory(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/ProductCategory/deleteProductCategory.graphql'),
            variables: {id}
        })
    }

}

export default new ProductCategoryProvider()


